import { useNetInfo } from '@react-native-community/netinfo'

import { useToast } from '@/src/general/components/ToastContext'
import { ICON } from '@/src/general/enums/icons'
import { isConfirmedOffline } from '@/src/general/utilities/netinfo/connectivity'
import { useTranslate } from '@/src/lang/useTranslate'

/**
 * Aligns interactive UI with Query's onlineManager (`!isConfirmedOffline`):
 * when confirmed offline, callers should toast instead of starting a paused mutation.
 */
export const useNotConnectedFeedback = () => {
  const netInfo = useNetInfo()
  const isOffline = isConfirmedOffline(netInfo)
  const { addToast } = useToast()
  const { t } = useTranslate()

  const showNotConnectedToast = () => {
    addToast({
      message: t('app-service.not-connected'),
      colors: 'danger',
      iconName: ICON.WIFI_OFF,
    })
  }

  return { isOffline, showNotConnectedToast }
}
